import { MedienGalerie } from '../components/MedienGalerie'

/** Seite „Medien“: Fotogalerie je Einsatz (auch abgeschlossene), Karte, Download und ZIP – admin-lokale Fassung der Galerie. */
export function MedienPage() {
  return <MedienGalerie />
}
